var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sjz",staticStyle:{"width":"100%"}},_vm._l((_vm.steps),function(item,index){return _c('div',{key:index,class:index === _vm.steps.length - 1 ? 'sjz-item' : 'sjz-kuaikuai'},[_c('div',{staticClass:"sjz-item"},[_c('div',{class:'sjz-icon ' +
            (index === _vm.activeIndex
              ? 'sjz-doing'
              : index > _vm.activeIndex
              ? 'sjz-done'
              : '')},[(index < _vm.activeIndex)?_c('i',{staticClass:"el-icon-check",staticStyle:{"width":"40px","height":"40px"}}):(index === _vm.activeIndex)?_c('span',{staticClass:"sjc-num sjc-do"},[_vm._v(_vm._s(index + 1))]):(index > _vm.activeIndex)?_c('span',{staticClass:"sjc-num"},[_vm._v(_vm._s(index + 1))]):_vm._e()]),_c('div',{class:'word-icon ' +
            (index === _vm.activeIndex
              ? 'word-do'
              : index > _vm.activeIndex
              ? 'word-undone'
              : '')},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])]),(index !== _vm.steps.length - 1)?_c('div',{class:'sjz-line ' + (index >= _vm.activeIndex ? 'sjz-undone' : '')}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }